import Api from '@/services/Api'

export default {
 getElements () {
   return Api().get("/elements");
},
  updateElement (params) {
    return Api().put("/elements",params);
  },
  addElement (params) {
    return Api().post("/elements",params);
  },
  getElement (params) {
    return Api().get("/elements/"+params);
  },
  getElementByType (params) {
    return Api().get("/elements-type/"+params);
  },
  deleteElement(params) {
    return Api().delete("/elements/"+params);
  },
  deleteElementsByType(params) {
    return Api().delete("/elements-type/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/ElementService.js